import { render, staticRenderFns } from "./servenav.vue?vue&type=template&id=58986052&scoped=true"
import script from "./servenav.vue?vue&type=script&lang=js"
export * from "./servenav.vue?vue&type=script&lang=js"
import style0 from "./servenav.vue?vue&type=style&index=0&id=58986052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58986052",
  null
  
)

export default component.exports